import { render, staticRenderFns } from "./MyInstructorsWidget.vue?vue&type=template&id=53afe6e9&scoped=true"
import script from "./MyInstructorsWidget.vue?vue&type=script&lang=js"
export * from "./MyInstructorsWidget.vue?vue&type=script&lang=js"
import style0 from "./MyInstructorsWidget.vue?vue&type=style&index=0&id=53afe6e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53afe6e9",
  null
  
)

export default component.exports